<template>
  <b-card-footer id="footer" footer-bg-variant="light">
    <slot name="footer-update"></slot>
    <b-row align-h="between" align-v="center">
      <b-col cols="auto" class="mr-auto">
        <slot name="footer-list">
          Записей: <b>{{ totalRows }}</b>
        </slot>
      </b-col>
      <b-col cols="auto">
        <b-form inline>
          <slot name="footer-buttons">
            <b-pagination-nav
              pills
              class="mr-2"
              :link-gen="linkGen"
              :number-of-pages="numberOfPages"
              :per-page="perPage"
              @page-click="onPagination"
            />
            <b-form-select
              class="mr-2"
              size="sm"
              :value="perPage"
              :options="pageOptions"
              @change="onPerPageChange"
            />
          </slot>
        </b-form>
      </b-col>
    </b-row>
  </b-card-footer>
</template>

<script>
export default {
  name: 'PaginationFooter',
  props: {
    totalRows: { type: Number, required: true },
    perPage: { type: Number, required: true },
    pageOptions: { type: Array, default: () => [10, 50, 100, 300, 500] }
  },
  computed: {
    numberOfPages() {
      const n = Math.ceil(this.totalRows / this.perPage);
      return n <= 0 ? 1 : n;
    }
  },
  methods: {
    linkGen(pageNum) {
      return '#page/' + pageNum;
    },
    onPagination(e, page) {
      this.$emit('page-click', e, page);
    },
    onPerPageChange(newValue) {
      this.$emit('per-page-change', newValue);
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/utilites/commonUi/PaginationFooter.vue